import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as API from "../api/index";
import * as Yup from "yup";
import { NotificationManager } from "react-notifications";

import { TextField } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import ConfirmAddDialog from "../util/confirmAddDialog";
import AddFormLayout from "../shared/AddFormLayout";
import SectionGrid from "../shared/SectionGrid";
import { useSectionedForm } from "../shared/useSectionedForm";

const FORM_SECTIONS = [
  {
    id: "details",
    label: "Task details",
    fields: ["query_id", "query_params", "entity", "service_name", "task_state"],
  },
];

const QueryScheduleTaskForm = () => {
  const validationSchema = Yup.object().shape({
    query_id: Yup.string().required("Query ID is required"),
    query_params: Yup.string().required("Query Parameters is required"),
    entity: Yup.string().required("Entity is required"),
    service_name: Yup.string().required("Service Name is required"),
    task_state: Yup.string().required("Task State is required"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const { sections, activeId, setActiveId } = useSectionedForm(
    FORM_SECTIONS,
    errors
  );

  const location = useLocation();
  const navigate = useNavigate();
  const taskMetaData = location.state;

  const items = ["Active", "Disable", "Not Active", "Pending", "Not Exist"];

  const onClickQuerySchedule = () => {
    navigate("/TaskSchedules");
  };

  const schedule_id = taskMetaData.schedule_id;
  const task_no = taskMetaData.task_no;
  const [pendingPayload, setPendingPayload] = useState(null);

  const onSubmit = (data) => {
    const payload = [
      {
        ...data,
        schedule_id: schedule_id,
        task_no: task_no,
      },
    ];

    setPendingPayload(payload);
  };

  const handleConfirmAdd = () => {
    const payload = pendingPayload;
    setPendingPayload(null);
    const resourcePath = "integrations/cfg/schedule/" + schedule_id + "/tasks";

    API.AddRecord(resourcePath, payload).then((response) => {
      if (response.code === 200) {
        NotificationManager.success(
          "Record added!",
          "Query Schedule Task",
          10000
        );
        navigate("/QueryScheduleTasks/" + schedule_id);
      } else {
        NotificationManager.error(response.message, "Failed!", 10000);
      }
    });
  };

  return (
    <>
      <AddFormLayout
        title="Add query schedule task"
        subtitle={`For schedule ${schedule_id}`}
        breadcrumbs={[
          { label: "Task schedules", onClick: onClickQuerySchedule },
          {
            label: schedule_id,
            mono: true,
            onClick: () => navigate(`/QueryScheduleTasks/${schedule_id}`),
          },
          { label: "Add task" },
        ]}
        sections={sections}
        activeSectionId={activeId}
        onSectionChange={setActiveId}
        primaryLabel="Add"
        onPrimaryClick={handleSubmit(onSubmit)}
      >
        <SectionGrid>
          <TextField
            required
            label="Query ID"
            size="small"
            fullWidth
            {...register("query_id")}
            error={!!errors.query_id}
            variant="outlined"
          />
          <TextField
            required
            label="Query Params"
            size="small"
            fullWidth
            {...register("query_params")}
            error={!!errors.query_params}
            variant="outlined"
          />
          <TextField
            required
            label="Entity"
            size="small"
            fullWidth
            {...register("entity")}
            error={!!errors.entity}
            variant="outlined"
          />
          <TextField
            required
            label="Service Name"
            size="small"
            fullWidth
            {...register("service_name")}
            error={!!errors.service_name}
            variant="outlined"
          />
          <TextField
            select
            label="Task State"
            size="small"
            fullWidth
            {...register("task_state")}
            error={!!errors.task_state}
            variant="outlined"
          >
            {items.map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </TextField>
        </SectionGrid>
      </AddFormLayout>
      <ConfirmAddDialog
        open={!!pendingPayload}
        onClose={() => setPendingPayload(null)}
        onConfirm={handleConfirmAdd}
        itemLabel="query schedule task"
      />
    </>
  );
};

export default QueryScheduleTaskForm;
